<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right"></div>
          <h4 class="page-title">Roles</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <b-card>
          <form action="">
            <div class="form-row">
              <div class="col-md-12 col-sm-12 col-lg-12">
                <label for="roles">Roles *</label>
                <multiselect
                  v-model="user.roles"
                  v-validate="'required'"
                  :multiple="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  label="name"
                  track-by="id"
                  :preselect-first="true"
                  :options="roles"
                  placeholder="Select Roles"
                  name="roles"
                  id="roles"
                ></multiselect>
                <div class="invalid-feedback">
                  Please Select Roles
                </div>
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="col">
                <button
                  class="btn btn-danger waves-effect waves-light mr-2"
                  @click.prevent="update"
                >
                  Add
                </button>
              </div>
            </div>
          </form>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import Multiselect from "vue-multiselect";

import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Role",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      title: "Role",
      items: [
        {
          text: "Role",
          href: "/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      validation_errors: {},
      user: {},
      roles: [],
    };
  },

  mounted() {
    this.user.user_id = this.$route.params.user_id;
    this.getRoles();
    this.getUserRoles(this.user.user_id);
  },
  methods: {
    getRoles() {
      http.get("api/getRoles").then(response => {
        if (!response.error) {
          this.roles = response.data.roles;
        }
      });
    },
    getUserRoles(user_id) {
      http
        .get("api/getUserRoles/" + user_id)
        .then(resource => {
          this.user = resource.data.user;
        })
        .catch();
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}
</style>
